import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, ArrowUp, Loader2, Crown } from "lucide-react";
import { useTheme } from "../../../contexts/ThemeContext";

const PromoteParticipantModal = ({
  members,
  selectedMember,
  setSelectedMember,
  onSubmit,
  onClose,
  loading,
}) => {
  const { theme } = useTheme();

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4"
      >
        <motion.div
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.9, opacity: 0 }}
          transition={{ type: "spring", damping: 20, stiffness: 300 }}
          className={`${theme.contentBg} ${theme.contentBorder}  rounded-xl shadow-2xl w-full max-w-md`}
        >
          {/* Header */}
          <div
            className={`${theme.grpBG} ${theme.headerBorder} border-b px-6 py-4 rounded-t-xl`}
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <div className="bg-primary-100 p-2 rounded-full">
                  <ArrowUp className="w-5 h-5 text-primary-600" />
                </div>
                <div>
                  <h3 className={`text-lg font-semibold ${theme.headerText}`}>
                    Promote Participant
                  </h3>
                  <p className={`text-xs ${theme.headerText} opacity-75`}>
                    Grant admin privileges to member
                  </p>
                </div>
              </div>
              <motion.button
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                onClick={onClose}
                className={`${theme.sidebarText} opacity-60 hover:opacity-100 transition-opacity`}
              >
                <X className="w-5 h-5" />
              </motion.button>
            </div>
          </div>

          {/* Content */}
          <div className="p-6 space-y-4">
            <div className="space-y-2">
              <label className={`text-sm font-medium ${theme.sidebarText}`}>
                Select Member to Promote
              </label>
              <motion.select
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.1 }}
                value={selectedMember || ""}
                onChange={(e) => setSelectedMember(e.target.value)}
                className={`w-full p-3 border ${theme.sidebarBorder} rounded-lg ${theme.sidebarBg} ${theme.sidebarText} ${theme.inputFocusRing} focus:border-transparent focus:ring-2 transition-all duration-200`}
              >
                <option value="">Select a member</option>
                {members.map((member) => (
                  <option key={member.id} value={member.id}>
                    {member.name || "Unnamed"} {member.admin && "(Admin)"}
                  </option>
                ))}
              </motion.select>
            </div>

            {selectedMember && (
              <motion.div
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.2 }}
                className="bg-primary-50 border border-primary-200 rounded-lg p-4"
              >
                <div className="flex items-center space-x-2">
                  <Crown className="w-4 h-4 text-primary-600" />
                  <span className="text-sm text-primary-800">
                    This will grant admin privileges to the selected member.
                  </span>
                </div>
              </motion.div>
            )}
          </div>

          {/* Footer */}
          <div
            className={`${theme.sidebarBg} ${theme.sidebarBorder} border-t px-6 py-4 rounded-b-xl`}
          >
            <div className="flex justify-end space-x-3">
              <motion.button
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                onClick={onClose}
                className={`px-4 py-2 ${theme.sidebarText} opacity-60 hover:opacity-100 transition-opacity rounded-lg text-sm font-medium`}
              >
                Cancel
              </motion.button>
              <motion.button
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                onClick={onSubmit}
                disabled={loading || !selectedMember}
                className="px-4 py-2 bg-primary-600 hover:bg-primary-700 text-white rounded-lg text-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed flex items-center space-x-2 transition-all duration-200"
              >
                {loading ? (
                  <>
                    <Loader2 className="w-4 h-4 animate-spin" />
                    <span>Promoting...</span>
                  </>
                ) : (
                  <>
                    <ArrowUp className="w-4 h-4" />
                    <span>Promote Member</span>
                  </>
                )}
              </motion.button>
            </div>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default PromoteParticipantModal;

// import React from 'react';

// const PromoteParticipantModal = ({ members, selectedMember, setSelectedMember, onSubmit, onClose, loading }) => {
//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
//       <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
//         <h3 className="text-2xl font-semibold text-red-600 mb-4">Promote Participant</h3>

//         <div>
//           <label className="block text-lg text-gray-700 mb-2">Select Member to Promote</label>
//           <select
//             value={selectedMember}
//             onChange={(e) => setSelectedMember(e.target.value)}
//             className="w-full p-2 border border-gray-300 rounded-lg mb-4"
//           >
//             {members.map((member) => (
//               <option key={member.id} value={member.id}>
//                 {member.name || 'Unnamed'}
//               </option>
//             ))}
//           </select>
//         </div>

//         <div className="flex justify-end space-x-4">
//           <button
//             onClick={onClose}
//             className="px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600"
//           >
//             Cancel
//           </button>
//           <button
//             onClick={onSubmit}
//             className="px-4 py-2 bg-yellow-600 text-white rounded-lg hover:bg-yellow-700"
//             disabled={loading || !selectedMember}
//           >
//             {loading ? (
//               <div className="animate-spin border-t-4 border-white rounded-full w-6 h-6 mx-auto"></div>
//             ) : (
//               'Promote Member'
//             )}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PromoteParticipantModal;
